<template>
    <div>
        <div class="container" v-if="action_loading">
            <div class="row">
                <div class="loading-sm"></div>
            </div>
        </div>
        <div v-else class="container">
            <div class="">
              <div>Order number: {{order_data.order_no}}</div>
              <div>Date: {{order_data.order_date}}</div>
              <div>Payment method: Online Payment</div>
              <div>Status: <span :style="{color:order_data.order_status_color}">{{order_data.order_status}}</span></div>
            </div>
            <div style="clear: both"></div>
            <div style="margin-top: 1em;">
                <div>Order Amount: &#8358;{{order_data.order_items_total}}</div>
                <div>Shipping:  &#8358;{{order_data.order_shipping_total}}</div>
                <div>Total: &#8358;{{order_data.order_total}}</div>
            </div>
            <div style="clear: both"></div>
            <div style="margin-top: 1em;">
              <div>Delivery Location: {{order_data.order_delivery_city}}</div>
              <div>Address: {{order_data.order_user_delivery_address}}</div>
            </div>
            <div class="">
              <table class="table table-striped" style="width:100%; text-align: left;">
                <th style="width:20%;" class="tcol">Order No</th>
                <th style="width:50%;" class="tcol">Order</th>
                <th style="width:10%;" class="tcol">Qty</th>
                <th style="width:20%;" class="tcol">Total</th>
                <tr v-for="item in order_data.order_items" :key="item.order_item_no">
                  <td style="width:20%; font-size: 12px;">
                    {{item.order_item_no}}
                  </td>
                  <td style="width:50%;">
                    {{item.product_name}}
                    <br>
                    <div style="display: inline;">
                      <img :src="img_product_url + item.product_item_group_image" height="50" width="50"/>
                    </div>
                  </td>
                  <td style="width:10%;">{{item.order_item_quantity}}</td>
                  <td style="width:20%;"><small>&#8358;</small>{{item.order_item_total.toFixed(2)}}</td>
                </tr>
              </table>
            </div>
            <div class="">
              <p><b>Commissions earned in this Order</b></p>
             <table class="table table-striped" style="width:100%; text-align: left;">
                <th style="width:20%;" class="tcol">Amount</th>
                <th style="width:50%;" class="tcol">Earner</th>
                <th style="width:10%;" class="tcol">Item</th>
                <!-- <th style="width:20%;" class="tcol">Total</th> -->
                <tr v-for="item in order_data.order_commissions_stl" :key="item.id">
                  <td style="width:20%; font-size: 11px;">
                    <small>&#8358;</small>{{item.service_commission_amount.toFixed(2)}}
                  </td>
                  <td style="width:30%;">
                    {{item.service_commission_earner_name}}
                  </td>
                  <td style="width:50%;">
                    {{item.service_commission_module_name}}
                    <br>
                    <div style="display: inline;">
                      <img :src="img_product_url + item.service_commission_module_image_url" height="50" width="50"/>
                    </div>
                  </td>
                  <!-- <td style="width:20%;"></td> -->
                </tr>
              </table>

              <div class="card-row">
                <h5>Order Additional Information</h5>
                <p style="color:#e94b4b">Add any order addtional information</p>
                <div v-if="setAddOrderAdditionalView">
                    <form class="form-inline">
                        <div class="row">
                            <div class="form-group wnf-fl-form-group col-xs-12">
                                <label class="">Title</label>
                                <input class="form-control input-bflat" type="text" v-model="order_add_info.title" title="Enter  name" placeholder=""/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group wnf-fl-form-group col-xs-12">
                                <label class="">Details</label>
                                <textarea class="form-control input-bflat" v-model="order_add_info.details" placeholder=""></textarea>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group wnf-fl-form-group col-xs-12">
                                <label class="">Cost</label>
                                <input class="form-control input-bflat" type="text" v-model="order_add_info.cost" title="Enter  name" placeholder=""/>
                            </div>
                        </div>
                    </form>
                    <div class="row">
                        <a style="cursor: pointer; color: #ffffff; text-decoration: none;" @click="addOrderAdditionalView">Add Information to Order</a>
                    </div>
                </div>
                <div v-else>
                    <a style="cursor: pointer; color: #ffffff; text-decoration: none;" @click="setAddOrderAdditionalView = true">Add Information</a>
                </div>
              </div>
              <!---->
              <div class="card-row">
                <h5>Process Order Request</h5>
                <p></p>
                <div><b>Send Bank Details</b><br>
                  <div v-if="sellpoint.business_bank_details && (Object.keys(sellpoint.business_bank_details).length > 0)">
                    <span>Send bank details details to receive order payment</span>
                    <div>
                      <p style="color:#444444;">{{ sellpoint.business_bank_details.bank_name }}<br>
                        {{ sellpoint.business_bank_details.bank_account_name }}<br>
                        {{ sellpoint.business_bank_details.bank_account_number }}
                      </p>
                    </div>
                    <button type="button" class="sp-button sp-button-lt" @click="setOrderCustomOrderDetailsUpdate(order_data)">Send</button>
                  </div>
                  <div v-else>
                    <p><b>Set Bank details</b></p>
                  </div>
                </div>
                <hr/>
                <p><b>Send Payment Link</b><br>
                  <span>A Payment link with payment details would be generated for payment</span><br><br>
                  <button type="button" class="sp-button sp-button-lt">Send Payment Link</button>
                </p>
                <hr/>
                <button type="button" class="sp-button sp-button-lt" @click="setMenuTabInnerView('ConfirmPaymentUpdate')">Confirm Payment</button>
                <div v-if="menu_tab_inner_view['ConfirmPaymentUpdate']">
                  <p style="color:#ff0000">Confirm Order Payment ?</p>
                  <button type="button" class="sp-button sp-button-lt" @click="setOrderCustomConfirmPaymentUpdate(order_data)">Yes, Confirm Payment</button>
                </div>
                <hr/>
                <hr/>
                <button type="button" class="sp-button sp-button-lt" @click="setOrderCustomUpdates(order_data,'delivered')">Mark as delivered</button>
                <hr/>
                <hr/>
                <button type="button" class="sp-button sp-button-lt" @click="setOrderCustomUpdates(order_data,'closed')">Close Order</button>
                <hr/>
                
                <div></div>
              </div>
              <!--./-->
            </div>
        
            <div class="mobile-fix-nav-2"  v-if="order_data.order_payment_status_id != 18">
                <p style="padding:0 5px">{{data_processing_message}}</p>
                <div v-if="order_data.order_status_id == 7" style="background: #e94b4b; width: 100vw; padding: 0.8em; text-align: center;">
                    <a style="cursor: pointer; color: #ffffff; text-decoration: none;" @click="updateOrders(order,'delivered')">Confirm Order </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style>

</style>
<script>
//import Account from './../../Resources/script.js'


import commonfunctions from "../../Resources/commonfunctions";
export default {
    mixins: [commonfunctions],
    props: ['order_data'],
    data () {
        return {
            order_add_info:{},
            setAddOrderAdditionalView:false,
        }
    },
    components: {
        
    },
     
    methods: {

        setPage(){
            this.loading = true;
            //check if request is a single order route
            let set_business = this.$route.params.business;
            let set_order_ref = this.$route.params.ref;
            if((set_business != undefined) && (set_business != '')){
                if((set_order_ref != undefined) && (set_order_ref != '')){
                    //get order details
                    var payload = {
                        ref: set_order_ref
                    }
                    this.getOrderDetails(payload);
                    //get business details
                }
            }
        },

      
    },

    created: function(){
        let self = this;
        localforage.getItem('xvue', function(err, value) { //quick with the callback version
            if(value != undefined) {
                self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
                //set sellpoint
                self.setPage();
            }else{}
        });
    }
}
</script>



// WEBPACK FOOTER //
// OrderDetailsRequest.vue?5316cf84